<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {

  created() {

    const token = localStorage.getItem("token");

    if (token) {

      this.$http.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    }

    this.$http.interceptors.response.use(

      response => response,

      (error) => {

        if (error.response && error.response.status === 401) {

          this.$store.dispatch("logout");

        }

        return Promise.reject(error);

      }

    );

  }

};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Sarabun&display=swap");
* {
  font-family: "Sarabun", sans-serif;
  border-radius: 0 !important;
}
</style>
